export const MEMBER_AREA_ROUTE_COMPANIONS = 'companions'
export const MEMBER_AREA_ROUTE_HOMEPAGE = 'homepage'
export const MEMBER_AREA_ROUTE_PAYMENTS = 'payments'
export const MEMBER_AREA_ROUTE_LOGIN = 'login'
export const MEMBER_AREA_ROUTE_FORGOT_PASSWORD = 'forgot-password'
export const MEMBER_AREA_ROUTE_RESET_PASSWORD = 'reset-password'
export const MEMBER_AREA_ROUTE_INFORMATIONS = 'informations'
export const MEMBER_AREA_ROUTE_DELIVERIES = 'deliveries'
export const MEMBER_AREA_ROUTE_PET_PRODUCTS = 'petsProducts'
export const MEMBER_AREA_ROUTE_PET_PRODUCT = 'petsProduct'
export const MEMBER_AREA_ROUTE_PRODUCTS = 'products'
export const MEMBER_AREA_ROUTE_PRODUCT = 'product'
export const MEMBER_AREA_ROUTE_PETS = 'pets'
export const MEMBER_AREA_ROUTE_MODIFY_PET_SUBSCRIPTION = 'modifyPetSubscription'
export const MEMBER_AREA_ROUTE_MODIFY_PET_MENU = 'modifyPetMenu'
export const MEMBER_AREA_ROUTE_SPONSORSHIP = 'sponsorship'
